<upp-overlay (OnClose)="OnClose()">
    <ion-header>
        <ion-toolbar>
            <ion-title slot="start">{{ tr('@product_number_search_title') }}</ion-title>
            <ion-buttons slot="end">
                <ion-button uppDataid="productmatch-close-button" (click)="OnClose()">
                    <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>

    <ion-content [scrollY]="false">
        <ion-item lines="none" (keyup.enter)="OnAccept()">
            <upp-input #input uppDataid="productmatch-code-input"
                class="code"
                type="text"
                [kiosk]="false"
                [(ngModel)]="SearchValue"
                placeholder="{{ tr('@product_number_search_number_ph') }}"
                title="{{ tr('@product_number_search_number') }}"
            ></upp-input>
        </ion-item>

        <div #scrbox class="scroll-box">
            <upp-scrollable>
                <ion-list>
                    <ion-item class="warning" [hidden]="!SearchValue.trim() || Matches.length > 0" lines="none">
                        <ion-icon slot="start" name="wine-outline"></ion-icon>
                        <ion-label>
                            {{ tr('@product_number_search_no_results_title') }}<br />
                            <span class="small">{{ tr('@product_number_search_no_results_message', [ SearchValue ]) }}</span>
                        </ion-label>
                    </ion-item>

                    <ion-item *ngFor="let _item of Matches" uppDataid="productmatch-item-row"
                        class="thumbnail"
                        lines="none"
                        (click)="OnSelectItem(_item)">
                        <ion-label slot="start" class="code">{{ ItemKey(_item) }}</ion-label>
                        <div class="item-body">
                            <upp-image [src]="ItemPhoto(_item) || '/assets/image/product.png'"></upp-image>
                            <ion-label>
                                {{ tr(_item.name) }}<br />
                                <span class="small" *ngIf="_item.ViewOf(Product) && tr(_item.description)">{{ tr(_item.description) }}</span>
                                <span class="small" *ngIf="!(_item.ViewOf(Product) && tr(_item.description))">{{ tr('@place_product_select_no_description') }}</span>
                            </ion-label>
                        </div>
                        <ion-label color="medium" class="price" *ngIf="ItemPrice(_item) as _price" slot="end">
                            {{ _price.int }}<span class="decimal">,{{ _price.dec }}</span>{{ tr('@currency') }}
                        </ion-label>
                    </ion-item>
                </ion-list>
            </upp-scrollable>
        </div>

        <div uppDataid="productmatch-numpad">
            <upp-numpad
                [disabled]="!CanAccept"
                (keyPress)="OnNumPad($event)"
                (accept)="OnAccept()"
            ></upp-numpad>
        </div>
    </ion-content>
</upp-overlay>
